import DefaultLayout from "../components/layout/DefaultLayout.jsx";
import CardGrid from "../components/content-blocks/CardGrid.jsx";
import CardContainer from "../components/content-blocks/CardContainer.jsx";

function Blog() {
    return (
        <DefaultLayout>
            <CardGrid rows = {5}>
                <CardContainer>
                    <div>
                        <h2>First Blog Post coming soon...</h2>
                    </div>
                </CardContainer>
            </CardGrid>
        </DefaultLayout>
    );
}

export default Blog;